module.exports = ".subtitle {\n  color: #98a6ad;\n  font-weight: 400; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/catalogo-productos/formulario-producto/formulario-producto.component.scss
// module id = ./src/app/components/catalogo-productos/formulario-producto/formulario-producto.component.scss
// module chunks = main